import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { generateSectionTitleStyles } from 'components/SectionTitle/SectionTitleStyles';
import { useTheme } from '@emotion/react';

export function SectionTitle({ title = '', sx = {} }) {
    const theme = useTheme();
    const styles = useMemo(() => generateSectionTitleStyles(theme), [theme]);

    return (
        <Box component="h2" sx={{ ...styles.title, ...sx }}>{title}</Box>
    );
}
